import React from 'react';
import './ContactPage.css';

const CONTACT_ITEMS = [
  {
    id: 'phone',
    label: 'טלפון',
    value: '08-9930666',
    hint: 'ימים א\'–ה\', 08:00–17:00',
    href: 'tel:089930666',
    iconSrc: '/img/IconPhone.png',
    iconAlt: 'טלפון',
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    value: '08-9930666',
    hint: 'שליחת הודעה מהירה',
    href: 'https://wa.me/97289930666',
    iconSrc: '/img/IconWhatsApp.png',
    iconAlt: 'WhatsApp',
    external: true,
  },
  {
    id: 'email',
    label: 'אימייל',
    value: 'office@trc.co.il',
    hint: 'נחזור אליך בהקדם האפשרי',
    href: 'mailto:office@trc.co.il',
    iconText: '@',
  },
  {
    id: 'website',
    label: 'אתר החברה',
    value: 'www.trc.co.il',
    hint: 'מידע נוסף על טרבלסי',
    href: 'https://www.trc.co.il',
    iconText: '↗',
    external: true,
  },
];

export default function ContactPage() {
  return (
    <div className="contact-page">
      <div className="contact-card">
        <div className="contact-card-header">
          <h3 className="contact-card-title">צור קשר</h3>
          <p className="contact-card-subtitle">נשמח לעמוד לרשותך – בחר/י את דרך ההתקשרות הנוחה לך</p>
        </div>

        <div className="contact-items">
          {CONTACT_ITEMS.map((item) => (
            <a
              key={item.id}
              className="contact-item"
              href={item.href}
              {...(item.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            >
              <div className="contact-item-top">
                <span className="contact-item-icon" aria-hidden="true">
                  {item.iconSrc ? (
                    <img src={item.iconSrc} alt="" className="contact-item-icon-img" />
                  ) : (
                    item.iconText
                  )}
                </span>
                <span className="contact-item-arrow" aria-hidden="true">←</span>
              </div>
              <span className="contact-item-body">
                <span className="contact-item-label">{item.label}</span>
                <span className="contact-item-value">{item.value}</span>
                <span className="contact-item-hint">{item.hint}</span>
              </span>
            </a>
          ))}
        </div>

        <p className="contact-footer-note">
          לתמיכה טכנית במערכת, ציין/י את שם המשתמש ופרויקט הרלוונטי.
        </p>
      </div>
    </div>
  );
}
